import { combineReducers } from "redux";
import rightSidebarReducer from "./reducer/rightSidebarReducer";
// import leftSidebarReducer from "./reducer/leftSidebarReducer"
import headerReducer from "./reducer/headerReducer";
import homeHeroReducer from "./reducer/homeHeroReducer";
import digitalSectionReducer from "./reducer/digitalSectionReducer";
import empoweringReducer from "./reducer/empoweringReducer";
import careerReducer from "./reducer/careerReducer";
import digitalCoreReducer from "./reducer/digitalCoreReducer";
import gridReducer from "./reducer/gridReducer";
import jobReducer from "./reducer/jobReducer";
import userReducer from "./reducer/userReducer"
import headerrReducer from "./reducer/headerrReducer";
import aboutusReducer from "./reducer/aboutusReducer";
import contactusReducer from "./reducer/contactusReducer";
import footerReducer from "./reducer/footerReducer";


const rootReducer = combineReducers({
  rightSidebar:rightSidebarReducer,
  // leftSidebar:leftSidebarReducer,
  header :headerReducer,
  homeHero: homeHeroReducer,
  digitalSection: digitalSectionReducer,
  empowering:empoweringReducer,
  career:careerReducer,
  digitalCore:digitalCoreReducer,
  gridData:gridReducer,
  job:jobReducer,
  user:userReducer,
  headerr:headerrReducer,
  aboutus:aboutusReducer,
  contactus:contactusReducer,
  footer:footerReducer,
});

export default rootReducer;
